import { Button } from 'components/elements'
import { getAlphaRgb } from 'components/layouts'
import Link from 'next/link'
import styled from 'styled-components'

const ParentSurveyContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 500px;
  padding: 24px 20px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  border-radius: 8px;
  margin-bottom: 10px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.white} 0%,
    ${({ theme }) => getAlphaRgb(theme.colors.primaryL, 0.35)} 100%
  );
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 4px 12px rgba(0, 124, 255, 0.12);
  }
`

const TsnLogo = styled.img`
  aspect-ratio: 300 / 143;
  width: 140px;
  object-fit: contain;
  margin-bottom: 12px;
`

const Kicker = styled.span`
  ${({ theme }) => theme.font.label}
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 6px;
`

const Headline = styled.p`
  ${({ theme }) => theme.font.h4}
  text-align: center;
  margin: 0 0 6px;
`

const SubLine = styled.p`
  ${({ theme }) => theme.font.body2}
  text-align: center;
  color: ${({ theme }) => theme.colors.grey};
  margin: 0 0 16px;
`

export const ParentSurveyBanner = () => {
  return (
    <ParentSurveyContainer href="/parent-survey">
      <TsnLogo src="/icons/tsn-logo.svg" alt="TrialSite News" />
      <Kicker>Parent Survey</Kicker>
      <Headline>
        Understanding Autism: A Parent Survey of Early Development
      </Headline>
      <SubLine>
        For parents of autistic children under age 20—with any developmental
        history.
      </SubLine>

      <Button variant="contained" color="primary" style={{ height: 'unset' }}>
        Learn more
      </Button>
    </ParentSurveyContainer>
  )
}

export default ParentSurveyBanner
